import React from "react";
import { Container } from "@chakra-ui/react";
import ListBotResponse from "views/admin/BotResponse/components/ListBotResponse";

const BotResponse = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListBotResponse />
    </Container>
  );
};

export default BotResponse;
